import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function ResumeSummaryExamples() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Resume Summary Examples (2026 Guide)"
        description="Discover the best resume summary examples for any job. Learn how to write a powerful resume summary and stand out to recruiters with EmployPilot."
        canonical="https://employpilot.com/resume-summary-examples"
      />

      <h1>Resume Summary Examples That Get Interviews</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Your resume summary is the first thing recruiters read. A strong summary can grab attention instantly
        and set the tone for your entire resume.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        A powerful resume summary highlights your value in just a few sentences.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Generate My Resume Summary
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What Is a Resume Summary?</h2>

      <p>
        A resume summary is a short introduction at the top of your resume that highlights your experience,
        skills, and key achievements.
      </p>

      <ul>
        <li>✔ 2–4 sentences long</li>
        <li>✔ Focused on value and results</li>
        <li>✔ Tailored to the job</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Resume Summary Examples</h2>

      <h3>Entry-Level Example</h3>
      <p>
        Motivated and detail-oriented graduate with strong communication and problem-solving skills.
        Eager to apply knowledge and grow within a professional environment.
      </p>

      <h3>Professional Example</h3>
      <p>
        Results-driven professional with 5+ years of experience improving processes and increasing efficiency.
        Proven ability to deliver measurable results and lead projects successfully.
      </p>

      <h3>Career Change Example</h3>
      <p>
        Adaptable professional transitioning into a new field, bringing strong transferable skills in leadership,
        communication, and problem-solving.
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Write a Strong Resume Summary</h2>

      <ol>
        <li>Start with your experience level</li>
        <li>Highlight key skills</li>
        <li>Include measurable achievements</li>
        <li>Keep it concise and clear</li>
      </ol>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Common Mistakes to Avoid</h2>

      <ul>
        <li>❌ Writing too much</li>
        <li>❌ Being too generic</li>
        <li>❌ Not showing results</li>
        <li>❌ Using weak language</li>
      </ul>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need help building your resume?{" "}
        <Link to="/ai-resume-builder">
          Use the AI Resume Builder
        </Link>
      </p>

      <p>
        Not sure what to include?{" "}
        <Link to="/best-resume-format">
          Learn the best resume format
        </Link>
      </p>

      <p>
        Switching careers?{" "}
        <Link to="/career-change-resume">
          See career change resume tips
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Build a Resume That Stands Out</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Start Now
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>What should a resume summary include?</h3>
      <p>
        It should include your experience, key skills, and measurable achievements.
      </p>

      <h3>How long should a resume summary be?</h3>
      <p>
        Typically 2–4 sentences that clearly highlight your value.
      </p>

      <h3>Can AI write my resume summary?</h3>
      <p>
        Yes. AI tools like EmployPilot can generate optimized summaries based on your experience.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default ResumeSummaryExamples;